import React from "react";
import Chart from "react-apexcharts";

const CurveChart = ({ data, xLabel, yLabel, seriesName, fillArea = false }) => {
  const categories = data?.map((item) => item?.empId);
  const values = data?.map((item) => parseFloat(item?.ratingNumber) || 0);

  const options = {
    chart: {
      id: "basic-line",
      toolbar: {
        show: true,
      },
      animations: {
        enabled: true,
        easing: 'linear',
        dynamicAnimation: {
          speed: 800
        }
      }
    },
    xaxis: {
      categories,
      title: {
        text: xLabel,
      },
    },
    yaxis: {
      title: {
        text: yLabel,
      },
      min: 0,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    colors: ["#059669"], // Updated color
    ...(fillArea && {
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 0.5,
          opacityFrom: 0.6,
          opacityTo: 0.1,
          stops: [0, 90, 100],
        },
      },
    }),
    dataLabels: {
      enabled: false,
    },
  };

  const series = [
    {
      name: seriesName,
      data: values,
    },
  ];

  return (
    <div>
      <Chart
        options={options}
        series={series}
        type={fillArea ? "area" : "line"}
        height={243} // Reduced height to fix scrolling issue!
      />
    </div>
  );
};

export default CurveChart;
